import { Injectable, signal } from '@angular/core'
import { AppUserGetAccountRec } from 'api'

interface ExtendedAppUserGetAccountRec extends AppUserGetAccountRec {
	birthDate?: string
}

const INITIAL_USER: ExtendedAppUserGetAccountRec = {
	id: '',
	email: '',
	firstName: '',
	identity: '',
	lastName: '',
	phoneNumber: '',
	role: '',
	username: '',
	referralCode: '',
	unsignedAgreements: [],
	acceptedSimpleAgreements: new Set<string>(),
	birthDate: '',
	shahkarVerified: false,
	profileImageFileId: undefined,
}

@Injectable({
	providedIn: 'root',
})
export class User {
	readonly #user = signal<ExtendedAppUserGetAccountRec>(INITIAL_USER)

	getUser() {
		return this.#user.asReadonly()
	}

	setUser(user: ExtendedAppUserGetAccountRec) {
		//@ts-ignore
		this.#user.set({ ...user, acceptedSimpleAgreements: new Set([...user.acceptedSimpleAgreements]) })
	}

	reset() {
		this.#user.set(INITIAL_USER)
	}

	update(user: Partial<ExtendedAppUserGetAccountRec>) {
		this.#user.update(current => ({ ...current, ...user }))
	}
}
